import { render, staticRenderFns } from "./ManageMenu.vue?vue&type=template&id=7451172e&scoped=true&"
import script from "./ManageMenu.vue?vue&type=script&lang=js&"
export * from "./ManageMenu.vue?vue&type=script&lang=js&"
import style0 from "./ManageMenu.vue?vue&type=style&index=0&id=7451172e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7451172e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7451172e')) {
      api.createRecord('7451172e', component.options)
    } else {
      api.reload('7451172e', component.options)
    }
    module.hot.accept("./ManageMenu.vue?vue&type=template&id=7451172e&scoped=true&", function () {
      api.rerender('7451172e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/ManageMenu.vue"
export default component.exports